import { render, staticRenderFns } from "./EditReportCategory.vue?vue&type=template&id=0c5ab471&scoped=true"
import script from "./EditReportCategory.vue?vue&type=script&lang=js"
export * from "./EditReportCategory.vue?vue&type=script&lang=js"
import style0 from "./EditReportCategory.vue?vue&type=style&index=0&id=0c5ab471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ab471",
  null
  
)

export default component.exports